export default "__VITE_ASSET__8U2m8ti___"